import { Workspace } from 'types'
import { DeactivateWorkspace } from '../Workspace/DeactivateWorkspace/DeactivateWorkspace'
import { DeactivateUser } from '../Account/DeactivateUser/DeactivateUser'
import SettingsStyles from '../SettingsModal.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useEffect, useState } from 'react'
import client from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import useIsMounted from 'ismounted'
import { WorkspaceSettings as WorkspaceSettingsType } from 'types'
import WorkspaceStyles from '../Workspace/WorkspaceSettings.module.scss'
import Styles from './DangerZone.module.scss'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { Modal } from 'almanac-ui/Modal'

interface Props {
  workspace: Workspace
}

export const DangerZone = ({ workspace }: Props) => {
  const isSettingsModalUpdateEnabled = useFlipperFlag('settings_modal_update')
  const { isMobile } = useResponsiveDesign()
  const [workspaceSettings, setWorkspaceSettings] = useState<WorkspaceSettingsType>()
  const isMounted = useIsMounted()

  useEffect(() => {
    if (!workspace?.key) return

    const loadWorkspaceSettings = async (workspaceKey: string) => {
      const res = await client.getWorkspaceSettings(workspaceKey)
      if (res.type === SUCCESS_RESPONSE_TYPE && isMounted.current) {
        setWorkspaceSettings(res.data.company)
      }
    }

    loadWorkspaceSettings(workspace.key)
  }, [workspace?.key, isMounted])

  return (
    <>
      {!isMobile && !isSettingsModalUpdateEnabled && (
        <header className={`${SettingsStyles.subHeader} ${Styles.header}`}>
          <Heading level={3}>Danger Zone</Heading>
        </header>
      )}
      {!isMobile && isSettingsModalUpdateEnabled && (
        <Modal.Header title="Danger Zone" className={SettingsStyles.newHeader} />
      )}

      <div className={Styles.section}>
        <div className={Styles.sectionHeader}>
          <Heading level={5}>Deactivate Workspace</Heading>
        </div>
        <div className={Styles.sectionContent}>
          <div className={Styles.warningText}>
            <p>
              Permanently deactivate this workspace. <strong>This action cannot be undone.</strong>
            </p>
            <p>
              Your subscription will canceled at the end of your current billing period. Any posts and integrations will
              be deactivated. All members will lose access to this workspace.
            </p>
          </div>
          <div className={Styles.buttonContainer}>
            <DeactivateWorkspace workspace={workspaceSettings} workspaceName={workspace.name} />
          </div>
        </div>
      </div>

      <div className={WorkspaceStyles.divider} />

      <div className={Styles.section}>
        <div className={Styles.sectionHeader}>
          <Heading level={5}>Delete Account</Heading>
        </div>
        <div className={Styles.sectionContent}>
          <div className={Styles.warningText}>
            <p>
              All of your data will be removed. <strong>This action cannot be undone.</strong>
            </p>
            <p>
              Immediately, you'll be signed out, your account will be deactivated, and your personal information will be
              removed. You will be removed from all workspaces. Any workspaces you solely manage will be deactivated.
            </p>
            <p>
              Note: You cannot delete your account if you're the only admin of a workspace with multiple members. Please
              assign another admin first.
            </p>
          </div>
          <div className={Styles.buttonContainer}>
            <DeactivateUser />
          </div>
        </div>
      </div>
    </>
  )
}
